import React, { useState, createContext } from "react";
import { globalState } from "../../state";

interface IState {
  loggedIn: boolean;
  setLoggedIn: (loggedIn: boolean) => void;
}

interface IProps {
  children?: React.ReactNode | React.ReactNode[];
}

const initialState: IState = {
  loggedIn: globalState.client.isLoggedIn,
  setLoggedIn: () => null,
};

export const AppContext = createContext<IState>(initialState);

export const AppContextProvider: React.FC = ({ children }: IProps) => {
  const [loggedIn, setLoggedIn] = useState<boolean>(
    globalState.client.isLoggedIn,
  );

  return (
    <AppContext.Provider value={{ loggedIn, setLoggedIn }}>
      {children}
    </AppContext.Provider>
  );
};
